/* eslint-disable indent */

import styled from 'styled-components'
import tokens from '../../components/tokens'

const { fonts } = tokens

export const Style = styled.div`
  height: 100%;
  width: 100%;
  align-items: flex-start;
  border-radius: 20px;
  box-shadow: 0 10px 10px 0
    ${props => props.shadow || 'rgba(143, 116, 255, 0.05)'};
  border: solid 1px ${props => props.border || '#e3dbff'};
  background-color: #ffffff;
  padding: ${props => props.padding};
  transition: all 0.3s ease-in;
  &:hover {
    box-shadow: ${props =>
      props.hover ? '0 8px 20px 0 rgba(29, 29, 29, 0.6)' : 'unset'};
    transition: all 0.3s ease-in;
  }
  .card-long-image {
    width: ${props => (props.imageAuto ? 'auto' : props.imageSize)};
    height: auto;
    object-fit: contain;
  }
  .icon-image {
    width: 12px;
    height: auto;
    object-fit: contain;
    margin-left: 5px;
    margin-top: -5px;
  }
  .text {
    width: ${props => `calc(100% - ${props.imageSize || 0})`};
    padding-left: 20px;
  }
  h4 {
    font-family: ${fonts.fontFamilyBasic};
    font-size: 15px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #555555;
    margin: 0 0 5px 0;
  }
  p {
    font-family: ${fonts.fontFamilyBasic};
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.61;
    letter-spacing: normal;
    color: #888888;
    margin: 0;
  }
  @media screen and (min-width: 300px) and (max-width: 768px) {
    .card-long-image {
      width: 80px !important;
      height: 80px;
      margin-right: 10px;
    }
    .text {
      padding-left: 0;
      width: 100%;
    }
    .icon-image {
      width: 12px !important;
      height: 12px;
      margin-left: 5px;
      margin-top: -5px;
    }
  }
  .container-item {
    display: flex;
    flex-direction: row;
  }
  .h4-black {
    font-family: ${fonts.fontFamilyBasic};
    font-size: 12px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #555555;
    margin: 0 0 10px 0;
  }
  .h4-orange {
    font-family: ${fonts.fontFamilyBasic};
    font-size: 12px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #ff7b1b;
    margin: 0 0 10px 0;
  }
  .container-work-detail {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 5px;
  }
  .read-more-work-detail {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .icon-images {
    width: 18px !important;
    height: 18px;
    margin-right: 10px;
  }
  .container-detail-work {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .alert-card {
    display: flex;
    flex-direction: row;
    padding: 15px;
    background-color: #f3f3f3;
    border-radius: 8px;
    justify-content: center;
  }
  .description-detail-work {
    margin-top: 12px;
    margin-bottom: 12px;
  }
  .sub-description-detail-work {
    display: flex;
    flex-direction: row;
  }
`
